const axios = require('axios')
const nuxtConfig = require('~/nuxt.config').default

// axios.defaults.withCredentials = 'include'

export const state = () => ({
	token: null,
	versionSuffix: '' // '-v2'
})

export const getters = {

}

export const mutations = {
	storeToken (state, token) {
		state.token = token
	},

	setApiVersion (state, version) {
		state.versionSuffix = `-${version}`
	}
}

export const actions = {
	setApiVersion ({ commit }, data) {
		commit('setApiVersion', data)
	},

	urlValidation ({ commit, state }, data) {
		return new Promise((resolve, reject) => {

			axios.post(`${nuxtConfig.env.apiURL}/property-contract${state.versionSuffix}/check-token`, data).then(res => {
				if (res.data && res.data.error === 0) {
					commit('storeToken', res.data.id)
					resolve(res.data)
				} else if (res.data.error === 422) { // Invalid token
					reject({
						code: 'invalid-token',
						...res.data
					})
				} else {
					reject({
						code: 'unknown',
						...res.data
					})
				}
			}).catch(e => {
				reject(e)
			})
		})
	},

	requestOTP ({ state }, data) {
		return new Promise((resolve, reject) => {
			axios.post(`${nuxtConfig.env.apiURL}/property-contract${state.versionSuffix}/request-otp`, {
				...data,
				id: state.token
			}).then(res => {
				if (res.data && res.data.error === 0) {
					resolve(res.data)
				} else {
					reject({
						code: 'unknown',
						...res.data
					})
				}
			}).catch(e => {
				reject(e)
			})
		})
	},

	verifyOTP ({ state }, data) {
		return new Promise((resolve, reject) => {

			axios.post(`${nuxtConfig.env.apiURL}/property-contract${state.versionSuffix}/submit-otp`, {
				...data,
				id: state.token
			}).then(res => {
				if (res.data && res.data.error === 0) {
					resolve(res.data)
				} else {
					reject({
						code: 'unknown',
						...res.data
					})
				}
			}).catch(e => {
				reject(e)
			})
		})
	},

	submitEmail ({ state }, data) {
		return new Promise((resolve, reject) => {
			axios.post(`${nuxtConfig.env.apiURL}/property-contract${state.versionSuffix}/submit-email`, {
				...data,
				id: state.token
			}).then(res => {
				if (res.data && res.data.error === 0) {
					resolve(res.data)
				} else {
					reject({
						code: 'unknown',
						...res.data
					})
				}
			}).catch(e => {
				reject(e)
			})
		})
	},

	submitPropertyId ({ state }, data) {
		return new Promise((resolve, reject) => {

			axios.post(`${nuxtConfig.env.apiURL}/property-contract${state.versionSuffix}/get-contract-by-propery-id`, {
				...data,
				id: state.token
			}).then(res => {
				if (res.data && res.data.error === 0) {
					resolve(res.data)
				} else {
					reject({
						code: 'unknown',
						...res.data
					})
				}
			}).catch(e => {
				reject(e)
			})
		})
	},

	submitInfo ({ state }, data) {
		return new Promise((resolve, reject) => {

			axios.post(`${nuxtConfig.env.apiURL}/property-contract${state.versionSuffix}/submit-customer`, {
				...data,
				id: state.token
			}).then(res => {
				if (res.data && res.data.error === 0) {
					resolve(res.data)
				} else {
					reject({
						code: 'unknown',
						...res.data
					})
				}
			}).catch(e => {
				reject(e)
			})
		})
	},

	submitCustomerProperty ({ state }, data) {
		return new Promise((resolve, reject) => {

			axios.post(`${nuxtConfig.env.apiURL}/property-contract${state.versionSuffix}/submit-customer-property`, {
				...data,
				id: state.token
			}).then(res => {
				if (res.data && res.data.error === 0) {
					resolve(res.data)
				} else {
					reject({
						code: 'unknown',
						...res.data
					})
				}
			}).catch(e => {
				reject(e)
			})
		})
	},

	submitProperty ({ state }, data) {
		return new Promise((resolve, reject) => {

			if (!data.rental_price) { // remove field if no data
				delete data['rental_price']
			}

			axios.post(`${nuxtConfig.env.apiURL}/property-contract${state.versionSuffix}/submit-property`, {
				...data,
				id: state.token
			}).then(res => {
				if (res.data && res.data.error === 0) {
					resolve(res.data)
				} else {
					reject({
						code: 'unknown',
						...res.data
					})
				}
			}).catch(e => {
				reject(e)
			})
		})
	},

	submitContract ({ state }, data) {
		return new Promise((resolve, reject) => {

			axios.post(`${nuxtConfig.env.apiURL}/property-contract${state.versionSuffix}/${data ? 'verify' : 'sign'}-contract`, {
				id: state.token
			}).then(res => {
				if (res.data && res.data.error === 0) {
					resolve(res.data)
				} else {
					reject({
						code: 'unknown',
						...res.data
					})
				}
			}).catch(e => {
				reject(e)
			})
		})
	},

	submitFile ({ state }, data) {
		return new Promise((resolve, reject) => {

			let form = new FormData()
			for (let key in data) {
				// skip loop if the property is from prototype
				if (!data.hasOwnProperty(key)) continue

				if (Array.isArray(data[key])) {
					for (let elm of data[key]) {
						form.append(`${key}[]`, elm || '')
					}
				} else {
					form.append(key, data[key] || '')
				}
			}
			form.append('id', state.token)

			axios.post(`${nuxtConfig.env.apiURL}/property-contract${state.versionSuffix}/uploads`, form, {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			}).then((res) => {
				if (res.data && res.data.error === 0) {
					resolve(res.data)
				} else {
					reject({
						code: 'unknown',
						...res.data
					})
				}
			}).catch(e => {
				reject(e)
			})
		})
	},

	submitIdentityPhoto ({ state }, data) {
		return new Promise((resolve, reject) => {
			axios.post(`${nuxtConfig.env.apiURL}/property-contract${state.versionSuffix}/photo-with-id-card`, {
				...data,
				id: state.token
			}).then((res) => {
				if (res.data && res.data.error === 0) {
					resolve(res.data)
				} else {
					reject({
						code: 'unknown',
						...res.data
					})
				}
			}).catch(e => {
				reject(e)
			})
		})
	},
}
